import {
  Button as AntdButton,
  Col as AntdCol,
  Row as AntdRow,
  DatePicker,
  Drawer,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Select,
  Space,
  Table,
  Tag,
} from "antd";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import axios from "axios";
import moment from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Folder, Info, PlusCircle, Target } from "react-feather";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { All, CreateNewProject } from "../../../../Constant";

import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import {
  CurrencyApi,
  OrganisationBranchApi,
  ProjectApi,
  ProjectPaginatedApi,
} from "../../../../api";
import { fetchLastProjectOfBranch } from "../../../../api/branch.api";
import {
  fetchOrganisationBranches,
  fetchOrganisationDetails,
} from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { checkIfOrgNeedsUpdate } from "../../../../utils/CheckFuncitons/OrganisationCheckFunctions";
import { Loader } from "../../../Loader";
import CusClass from "../Common/CusClass";
import "./index.css";

// import { useRef } from "react";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Project = (props) => {
  const { Option } = Select;
  const { TextArea } = Input;
  const logger = React.useContext(LoggerContext);

  const history = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [projectList, setProjectList] = useState([]);
  const { userDetails, setUserDetails } = useAPIUser();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [currency, setCurrency] = useState([]);
  const [sortBy, setSortBy] = useState("-created_at");
  const [branches, setBranches] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [
    organisationDetailsFillCardVisible,
    setOrganisationDetailsFillCardVisible,
  ] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [userDetailsModalVisible, setUserDetailsModalVisible] = useState(false);
  const [noProjectsInBranchCardVisible, setNoProjectsInBranchCardVisible] =
    useState(false);
  const [
    noBranchInOrganisationCardVisible,
    setNoBranchInOrganisationCardVisible,
  ] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [lastProjectName, setLastProjectName] = useState("");

  const [view, setView] = useState("grid");

  const searchInput = useRef(null);

  var formRef = useRef();
  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    formRef.current.resetFields();
    setVisible(false);
  };

  const getOrgDetails = async () => {
    const org_details = await fetchOrganisationDetails();
    const needsUpdate = checkIfOrgNeedsUpdate({ org_details: org_details });
    console.log("org", org_details);
    setOrganisationDetailsFillCardVisible(needsUpdate);
    if (!needsUpdate) {
      checkBranches();
    }

    return org_details;
  };

  const checkBranches = async () => {
    fetchOrganisationBranches({
      organisation_id: props?.settings?.user?.organisation?.organisation_id,
    }).then((branches) => {
      if (branches?.length == 0) {
        setNoBranchInOrganisationCardVisible(true);
      } else {
        setNoBranchInOrganisationCardVisible(false);
      }
    });
  };
  const fetchProjects = (params = {}) => {
    setLoading(true);
    return axios
      .get(`${ProjectPaginatedApi}`, {
        params: { ...params, ordering: sortBy, page: page },
      })
      .then((res) => {
        setTotalPages(res?.data?.count ?? 10);
        setProjectList(res.data?.results);
        return res.data;
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };
  const onUpdate = (id) => {
    setEditId(id);
    setVisible(true);
    axios.get(`${ProjectApi}${id}/`).then((res) => {
      console.log(res.data);
      formRef.current.setFieldsValue({
        title: res.data?.project_name,
        start_date: moment(res.data?.start_date),
        end_date: moment(res.data?.end_date),
      });
    });
  };
  const fetchCurrency = () => {
    axios
      .get(`${CurrencyApi}`)
      .then((res) => {
        setCurrency(res.data);
      })
      .catch(() => {});
  };

  const fetchBranches = () => {
    return axios
      .get(`${OrganisationBranchApi}`)
      .then((res) => {
        setBranches(res.data);
      })
      .catch(() => {});
  };

  const currencyOption = currency?.map((each) => (
    <Option key={each.id} value={each.id}>
      {each.name}
      {` ( ${each.symbol} )`}
    </Option>
  ));
  const branchOption = branches?.map((each, ind) => (
    <Option key={each?.id} value={each.id}>
      {each.branch_name}
    </Option>
  ));

  const fetchAll = () => {
    fetchProjects({ branch: props?.settings?.branch?.id });
    fetchLastProjectOfBranch({
      params: { branch_id: props?.settings?.branch?.id },
    }).then((res) => {
      setLastProjectName(res?.project_name);
    });
    fetchCurrency();
    fetchBranches();
    getOrgDetails();
    // setBranchFromProject();
  };

  useEffect(() => {
    const { dispatch } = props;

    logger.log(LogEvents.allProject, {
      organizationBranchName: props?.settings?.branch?.branch_name,
      organizationBranchId: props?.settings?.branch?.id,
    });
    fetchAll();
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: { setting: "projectSelected", value: false },
    });
  }, []);

  useEffect(() => {
    if (loading) {
      setNoProjectsInBranchCardVisible(false);
      return;
    }
    if (projectList?.length == 0 && activeTab == "1" && search == "") {
      setNoProjectsInBranchCardVisible(true);
    } else {
      setNoProjectsInBranchCardVisible(false);
    }
  }, [projectList, loading]);

  const fetchProjectsWithFilters = () => {
    let params = {
      branch: props?.settings?.branch?.id,
    };
    if (activeTab == "2") {
      params = { ...params, is_archived: false };
    }
    if (activeTab == "3") {
      params = { ...params, is_archived: true };
    }

    if (search != "") {
      params = { ...params, search: search };
    }
    fetchProjects({ ...params });
  };

  useEffect(() => {
    fetchProjectsWithFilters();
  }, [props?.settings?.branch?.id, sortBy, page]);

  useEffect(() => {
    const user = props?.settings?.user;
    if (
      user?.id &&
      (!user?.name ||
        user?.name?.length == 0 ||
        !user?.email ||
        user?.email?.length == 0)
    ) {
      setUserDetailsModalVisible(true);
    }
  }, [props?.settings?.user]);
  const addProject = () => {
    const updatedValues = formRef.current.getFieldsValue();
    console.log("updatedValues", updatedValues);
    const values = new FormData();
    values.append(
      "start_date",
      moment(updatedValues?.start_date).format("YYYY-MM-DD")
    );
    values.append(
      "end_date",
      moment(updatedValues?.end_date).format("YYYY-MM-DD")
    );
    if (updatedValues?.title) {
      values.append("project_name", updatedValues?.title);
    }
    if (updatedValues?.project_code) {
      values.append("project_code", updatedValues?.project_code);
    }
    values.append("organisation", userDetails?.organisation?.organisation_id);
    values.append("project_address", updatedValues?.project_address ?? "");
    values.append("pincode", updatedValues?.pincode ?? "");
    values.append("city", updatedValues?.city ?? "");
    values.append("contact_phone", updatedValues?.contact_phone ?? "");
    values.append("contact_email", updatedValues?.contact_email ?? "");
    values.append("contact_person", updatedValues?.contact_person ?? "");
    values.append(
      "branch",
      updatedValues?.branch ?? props?.settings?.branch?.id
    );
    values.append("currency", props?.settings?.branch?.currency ?? 1);
    if (editId) {
      axios
        .put(`${ProjectApi}${editId}/`, values)
        .then((res) => {
          fetchProjects({ branch: props?.settings?.branch?.id });
          toast.success("Project Edited");
          onClose();
        })
        .catch((error) => {
          if (error?.response?.status == 405) {
            toast.error(error?.response?.data);
          }
        });
    } else {
      axios
        .post(`${ProjectApi}`, values)
        .then((res) => {
          fetchProjects({ branch: props?.settings?.branch?.id });
          toast.success("Project Added");
          logger.log(LogEvents.createProjectSuccess, {});
          onClose();
        })
        .catch((error) => {
          if (error?.response?.status == 405) {
            toast.error(error?.response?.data);
          }
        });
    }
  };
  const handleDeleteProject = React.useCallback(
    (id) => {
      axios
        .delete(`${ProjectApi}${id}/`)
        .then((res) => {
          fetchProjects({ branch: props?.settings?.branch?.id });
          toast.success("Project Deleted");
        })
        .catch(() => {});
    },
    [props?.settings?.branch?.id]
  );

  const fetchProjectsAccordingToTab = React.useCallback(() => {
    if (props?.settings?.branch?.id) {
      console.log("activeTab", activeTab);
      setProjectList([]);
      if (activeTab == "1") {
        fetchProjects({ branch: props?.settings?.branch?.id });
      } else if (activeTab == "2") {
        fetchProjects({
          branch: props?.settings?.branch?.id,
          is_archived: false,
        });
      } else {
        fetchProjects({
          branch: props?.settings?.branch?.id,
          is_archived: true,
        });
      }
    }
  }, [activeTab, props?.settings?.branch?.id]);

  const handleArchive = React.useCallback(
    (id, value) => {
      const values = new FormData();
      values.append("is_archived", value);

      // values.append("branch", updatedValues?.branch);
      axios
        .put(`${ProjectApi}${id}/`, values)
        .then((res) => {
          toast.success(value ? "Project archived!" : "Project un-archived");
          fetchProjectsAccordingToTab();
        })
        .catch(() => {
          toast.error("Something went wrong. Please try again later.");
        });
    },
    [fetchProjectsAccordingToTab]
  );

  useEffect(() => {
    fetchProjectsAccordingToTab();
  }, [activeTab]);

  const getPercentSpent = (item) => {
    let poRaised = parseFloat(item?.po_raised ?? 0)?.toFixed(2) ?? 0;
    let budget = parseFloat(item?.total_budget ?? 0)?.toFixed(2) ?? 0;

    const percent = (
      (parseFloat(poRaised / budget ?? 0)?.toFixed(2) ?? 0) * 100
    ).toString();
    var percentString = percent.split(".")[0];
    if (poRaised === 0) {
      return 0;
    }
    return percentString;
  };

  function numDifferentiation(value) {
    var val = Math.abs(value) ?? 0;
    if (val >= 10000000) {
      val = (val / 10000000 ?? 0).toFixed(2) + " Cr";
    } else if (val >= 100000) {
      val = (val / 100000 ?? 0).toFixed(2) + " Lakhs";
    }
    return val;
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <AntdButton
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </AntdButton>
          <AntdButton
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </AntdButton>
          <AntdButton
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </AntdButton>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={
            ("pincode" ? String(text).replace(/\..*$/, "") : text)
              ? ("pincode"
                  ? String(text).replace(/\..*$/, "")
                  : text
                ).toString()
              : ""
          }
        />
      ) : dataIndex === "pincode" ? (
        String(text).replace(/\..*$/, "")
      ) : (
        text
      ),
  });

  const tableColumns = React.useMemo(() => {
    return [
      {
        key: "project_name",
        title: "Project Name",
        dataIndex: "project_name",
        onFilter: (value, record) => record.project_name.indexOf(value) === 0,
        sorter: (a, b) => a.project_name.length - b.project_name.length,
        ...getColumnSearchProps("project_name"),
      },
      {
        key: "project_code",
        title: "Project Code",
        dataIndex: "project_code",
        onFilter: (value, record) => record.project_code.indexOf(value) === 0,
      },
      {
        key: "project_id",
        title: "Project ID",
        dataIndex: "id",
        onFilter: (value, record) => record.project_name.indexOf(value) === 0,
        sorter: (a, b) => a.project_name.length - b.project_name.length,
        ...getColumnSearchProps("project_name"),
      },
      {
        key: "project_city",
        title: "City",
        dataIndex: "city",
        onFilter: (value, record) => record.city.indexOf(value) === 0,
        sorter: (a, b) => a.city.length - b.city.length,
        ...getColumnSearchProps("city"),
      },
      {
        key: "budget_spent",
        title: "Budget Spent",
        render: (item) =>
          `${
            isNaN(getPercentSpent(item)) ? 0 : getPercentSpent(item)
          }% of ${numDifferentiation(item?.total_budget)}`,
        sorter: (a, b) =>
          parseInt(getPercentSpent(a), 10) - parseInt(getPercentSpent(b), 10),
      },
      {
        key: "po_raised",
        title: "POs Raised",
        dataIndex: "no_po_raised",
        sorter: (a, b) => a.no_po_raised - b.no_po_raised,
      },
      {
        key: "actions",
        title: "Actions",
        render: (item) => (
          <Space>
            <Tag
              color={item?.is_archived ? "green" : "orange"}
              onClick={(ev) => {
                ev.stopPropagation();
                handleArchive(item.id, !item?.is_archived);
              }}
              style={{ cursor: "pointer" }}
            >
              {item?.is_archived ? "Un-Archive" : "Archive"}
            </Tag>
            <Tag
              color="red"
              onClick={(ev) => {
                ev.stopPropagation();
                handleDeleteProject(item.id);
              }}
              style={{ cursor: "pointer" }}
            >
              Delete
            </Tag>
          </Space>
        ),
      },
    ];
  }, [handleArchive, handleDeleteProject]);

  const goToProject = (project) => {
    const { dispatch } = props;

    logger.log(LogEvents.selectProject, {});
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: project,
      },
    });
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "projectSelected",
        value: true,
      },
    });
    history(`/project-dashboard/` + project?.id);
  };

  const getView = () => {
    if (view === "grid") {
      if (loading) {
        return <Loader />;
      }

      return (
        <Row>
          {projectList
            // ?.filter((project) => {
            //   return project?.project_name
            //     ?.toLowerCase()
            //     ?.includes(search?.toLowerCase());
            // })
            ?.map((item, i) => (
              <CusClass
                handleDelete={handleDeleteProject}
                handleArchive={handleArchive}
                onEdit={() => {
                  onUpdate(item.id);
                }}
                item={item}
                key={i}
              />
            ))}
        </Row>
      );
    }

    return (
      <Table
        columns={tableColumns}
        dataSource={projectList
          ?.filter((project) => {
            return project?.project_name
              ?.toLowerCase()
              ?.includes(search?.toLowerCase());
          })
          .sort((a, b) => {
            return new Date(b?.modified_at) - new Date(a?.modified_at);
          })}
        rowClassName={() => "cursor-pointer"}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
        }}
        rowKey="id"
        loading={loading}
        style={{
          marginBottom: 30,
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              goToProject(record);
            },
          };
        }}
      />
    );
  };

  return (
    <Fragment>
      {noProjectsInBranchCardVisible &&
        !noBranchInOrganisationCardVisible &&
        !organisationDetailsFillCardVisible && (
          <Col>
            <Card className="setup-required px-2">
              <Row className="p-2">
                <div className="col-9 py-1">
                  Currently there are no projects in this branch please create
                  project to raise PO/WOs.
                </div>
                <div className="col-3 d-flex justify-content-end">
                  <Button
                    onClick={() => {
                      showDrawer();
                    }}
                    className="setup-required-btn"
                  >
                    Create Project
                  </Button>
                </div>
              </Row>
            </Card>
          </Col>
        )}

      {noBranchInOrganisationCardVisible &&
        !organisationDetailsFillCardVisible && (
          <Col>
            <Card className="setup-required px-2">
              <Row className="p-2">
                <div className="col-9 py-1">
                  Currently there are no branches in your organisation please
                  create a branch to add projects.
                </div>
                <div className="col-3 d-flex justify-content-end">
                  <Button
                    onClick={() => {
                      history(`/app/organisation?tab=2`);
                    }}
                    className="setup-required-btn"
                  >
                    Create Branch
                  </Button>
                </div>
              </Row>
            </Card>
          </Col>
        )}
      {organisationDetailsFillCardVisible && (
        <Col>
          <Card className="setup-required px-2">
            <Row className="p-2">
              <div className="col-9 py-1">
                Organisation Details are incomplete. Please fill all the details
                to create PO/WOs
              </div>
              <div className="col-3 d-flex justify-content-end">
                <Button
                  onClick={() => {
                    history(`/app/organisation`);
                  }}
                  className="setup-required-btn"
                >
                  Organisation Details
                </Button>
              </div>
            </Row>
          </Card>
        </Col>
      )}
      <Container fluid={true}>
        {!noProjectsInBranchCardVisible &&
          !noBranchInOrganisationCardVisible &&
          !organisationDetailsFillCardVisible && (
            <Row>
              <Col md="12" className="project-list">
                <Card>
                  <Row>
                    <Col sm="4">
                      <Nav tabs className="border-tab">
                        <NavItem>
                          <NavLink
                            className={activeTab === "1" ? "active" : ""}
                            onClick={() => setActiveTab("1")}
                          >
                            <Target />
                            {All}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={activeTab === "2" ? "active" : ""}
                            onClick={() => setActiveTab("2")}
                          >
                            <Info />
                            Ongoing
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={activeTab === "3" ? "active" : ""}
                            onClick={() => setActiveTab("3")}
                          >
                            <Folder />
                            Archived
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>

                    <Col sm="8">
                      <Space
                        align="end"
                        style={{ justifyContent: "flex-end", width: "100%" }}
                      >
                        <Input.Search
                          type="text"
                          placeholder="Search"
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          onSearch={() => {
                            fetchProjectsWithFilters();
                          }}
                        />
                        <AntdButton
                          onClick={(e) => {
                            logger.log(LogEvents.createProjectInitiate, {});
                            showDrawer();
                          }}
                          type="primary"
                        >
                          <Space>
                            <PlusCircle size={20} />
                            {CreateNewProject}
                          </Space>
                        </AntdButton>
                        <Radio.Group
                          onChange={({ target: { value } }) => {
                            setView(value);
                          }}
                          value={view}
                          buttonStyle="solid"
                        >
                          <Radio.Button value="grid">Grid</Radio.Button>
                          <Radio.Button value="list">List</Radio.Button>
                        </Radio.Group>
                      </Space>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <Row
                      style={{
                        justifyContent: "end",
                        alignItems: "center",
                        margin: "8px 0",
                      }}
                    >
                      {props.settings?.organisation?.lead_field && (
                        <Col>
                          <Tag color="cyan">
                            Last Project Created: {lastProjectName}
                          </Tag>
                        </Col>
                      )}
                      Sort By:{" "}
                      <Select
                        defaultValue="-created_at"
                        style={{
                          width: 200,
                        }}
                        onChange={(e) => {
                          setSortBy(e);
                        }}
                        options={[
                          {
                            value: "created_at",
                            label: "Date created asc",
                          },
                          {
                            value: "-created_at",
                            label: "Date created desc",
                          },
                          {
                            value: "modified_at",
                            label: "Date modified asc",
                          },
                          {
                            value: "-modified_at",
                            label: "Date modified desc",
                          },
                          {
                            value: "project_name",
                            label: "Name asc",
                          },
                          {
                            value: "-project_name",
                            label: "Name asc",
                          },
                        ]}
                      />
                    </Row>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">{getView()}</TabPane>
                      <TabPane tabId="2">{getView()}</TabPane>
                      <TabPane tabId="3">{getView()}</TabPane>
                    </TabContent>

                    <Pagination
                      showSizeChanger={false}
                      current={page}
                      total={totalPages}
                      className="mt-3"
                      onChange={(p) => {
                        setPage(p);
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
      </Container>
      <Drawer
        title="Create Project"
        width={500}
        onClose={() => {
          onClose();
        }}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <AntdButton
              onClick={() => {
                onClose();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </AntdButton>
            <AntdButton
              className="btn btn-primary"
              form="projectForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </AntdButton>
          </div>
        }
      >
        <Form
          layout="vertical"
          id="projectForm"
          ref={formRef}
          onFinish={addProject}
        >
          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item
                name={"title"}
                label="Project name"
                rules={[
                  {
                    required: true,

                    message: "Project name is required",
                  },
                ]}
              >
                <Input placeholder="Project name" />
              </Form.Item>
            </AntdCol>
            <AntdCol sm={12}>
              <Form.Item
                name={"project_code"}
                label="Project Code"
                rules={[
                  {
                    required: true,
                    message: "Project code is required",
                  },
                ]}
              >
                <Input placeholder="Project code" />
              </Form.Item>
            </AntdCol>
            <AntdCol sm={12}>
              <Form.Item name={"contact_person"} label="Contact Person">
                <Input placeholder="Contact Person" />
              </Form.Item>
            </AntdCol>
            {/* <AntdCol sm={12}>
              <Form.Item name={"branch"} label="Branch">
                <Select
                  defaultValue={props?.settings?.branch?.id}
                  placeholder="Select Branch"
                >
                  {branchOption}
                </Select>
              </Form.Item>
            </AntdCol> */}
          </AntdRow>

          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item name={"start_date"} label="Start Date">
                <DatePicker placeholder="Start Date" className="w-100" />
              </Form.Item>
            </AntdCol>
            <AntdCol sm={12}>
              <Form.Item name={"end_date"} label="End Date">
                <DatePicker placeholder="End Date" className="w-100" />
              </Form.Item>
            </AntdCol>
          </AntdRow>

          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                    message: "Enter valid city",
                  },
                ]}
              >
                <Input placeholder="Enter city" />
              </Form.Item>
            </AntdCol>
            <AntdCol sm={12}>
              <Form.Item
                name={"contact_phone"}
                label="Contact Number"
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]{10}$/,
                    message: "Enter a valid 10 digit contact number",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={10}
                  minLength={10}
                  placeholder="Enter contact number"
                />
              </Form.Item>
            </AntdCol>
          </AntdRow>
          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item name={"contact_email"} label="Email">
                <Input placeholder="Enter contact email" />
              </Form.Item>
            </AntdCol>

            <AntdCol sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    pattern: /[1-9][0-9]{5}$/,
                    message: "Enter valid pincode",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={6}
                  minLength={6}
                  placeholder="Enter pincode"
                />
              </Form.Item>
            </AntdCol>
          </AntdRow>
          <AntdRow gutter={24}>
            <AntdCol sm={24}>
              <Form.Item name={"project_address"} label="Address">
                <TextArea rows={4} placeholder="Enter address" />
              </Form.Item>
            </AntdCol>
          </AntdRow>
        </Form>
      </Drawer>

      <Modal
        title="Fill details"
        centered
        visible={userDetailsModalVisible}
        footer={null}
        onCancel={() => setUserDetailsModalVisible(false)}
        width={"40%"}
        className="no-budget-item-modal-style"
      >
        <Col className="p-2 px-4 text-center">
          <Col className="px-5 text-center">
            It looks like some of your profile details are not filled yet. You
            can edit your profile details by clicking the user icon on the top
            right corner.
          </Col>
          <Button
            className="mt-2 btn-primary"
            type="primary"
            onClick={() => {
              history(`/app/users/userEdit`);
            }}
          >
            Go to User Profile
          </Button>
        </Col>
      </Modal>
    </Fragment>
  );
};

export default connect(mapStateToProps)(Project);
